/**
 * File: useTourState.ts
 * Path: apps/admin/src/shared/hooks/useTourState.ts
 * Description: Which tutorial is running and on which step, and whether the
 * Help dialog is open. Nothing is saved: a tutorial belongs to the moment
 * you press "Show me".
 */

import { create } from "zustand";
import type { TourStep } from "../utils/tutorialTypes";

interface TourState {
  steps: TourStep[];
  /** The running tutorial's title, for the step label. */
  title: string;
  index: number;
  running: boolean;
  start: (steps: TourStep[], title?: string) => void;
  next: () => void;
  back: () => void;
  stop: () => void;
}

export const useTour = create<TourState>((set, get) => ({
  steps: [],
  title: "",
  index: 0,
  running: false,
  start: (steps, title = "") => set({ steps, title, index: 0, running: steps.length > 0 }),
  next: () => {
    const { index, steps } = get();
    set(index + 1 >= steps.length ? { running: false, steps: [], title: "", index: 0 } : { index: index + 1 });
  },
  back: () => set({ index: Math.max(0, get().index - 1) }),
  stop: () => set({ running: false, steps: [], title: "", index: 0 }),
}));

interface HelpState {
  open: boolean;
  openHelp: () => void;
  closeHelp: () => void;
}

/** The Help dialog the ? icon opens. */
export const useHelp = create<HelpState>((set) => ({
  open: false,
  openHelp: () => set({ open: true }),
  closeHelp: () => set({ open: false }),
}));
